/* eslint-env node, browser */
'use strict'

module.exports = function () {
  var self = this

  self.instances.forEach(function (combokeys) {
    combokeys.reset()
  })
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/combokeys/Combokeys/reset.js
// module id = 1552
// module chunks = 2